/* eslint-disable no-unused-vars */
// TODO: remove later
import React, { useMemo } from 'react';
import clsx from 'clsx';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  makeStyles
} from '@material-ui/core';
import { formatCurrency, marginColorViaGross } from 'src/utils';
import { colors } from 'src/constants';
import { slices, useAppSelector } from 'src/redux';

const { selectors: inventorySelectors } = slices.inventory;

interface Props {
  className?: string;
}

const useStyles = makeStyles(() => ({
  root: {},
  cardContent: {
    flexDirection: 'row'
  },
  totalContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column'
  },
  gross: {
    color: colors.success
  }
}));

const InventoryToolbar = ({ className, ...rest }: Props) => {
  const classes = useStyles();

  const totalDP = useAppSelector(inventorySelectors.selectTotalDP);
  const totalRP = useAppSelector(inventorySelectors.selectTotalRP);
  const totalGP = useAppSelector(inventorySelectors.selectTotalGP);
  const marginPercentage = useAppSelector(inventorySelectors.selectMargin);

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Box mt={3}>
        <Card>
          <CardContent>
            <Grid container spacing={8} alignItems="center" justify="center">
              <Grid item>
                <div className={classes.totalContainer}>
                  <Typography variant="h5" color="textSecondary">
                    Total Retail Price
                  </Typography>
                  <Typography variant="h4" color="primary">
                    {formatCurrency(totalRP)}
                  </Typography>
                </div>
              </Grid>

              <Grid item>
                <div className={classes.totalContainer}>
                  <Typography variant="h5" color="textSecondary">
                    Total Gross Price
                  </Typography>
                  <Box className={classes.totalContainer}>
                    <Typography variant="h2" className={classes.gross}>
                      {formatCurrency(totalGP)}
                    </Typography>
                    {marginPercentage && (
                      <Typography
                        variant="h6"
                        color="primary"
                        style={{
                          color: marginColorViaGross(marginPercentage)
                        }}
                      >
                        {`${marginPercentage}`}
                      </Typography>
                    )}
                  </Box>
                </div>
              </Grid>

              <Grid item>
                <div className={classes.totalContainer}>
                  <Typography variant="h5" color="textSecondary">
                    Total Dealers Price
                  </Typography>
                  <Typography variant="h4" color="primary">
                    {formatCurrency(totalDP)}
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </div>
  );
};

export default InventoryToolbar;
